export const agencesConstants = {
    AGENCES_FETCH_REQUEST: "AGENCES_FETCH_REQUEST",
    AGENCES_FETCH_SUCCESS: "AGENCES_FETCH_SUCCESS",
    AGENCES_FETCH_FAILURE: "AGENCES_FETCH_FAILURE",

    AGENCES_FETCH_ONE_REQUEST: "AGENCES_FETCH_ONE_REQUEST",
    AGENCES_FETCH_ONE_SUCCESS: "AGENCES_FETCH_ONE_SUCCESS",
    AGENCES_FETCH_ONE_FAILURE: "AGENCES_FETCH_ONE_FAILURE",

    AGENCES_CREATE_REQUEST: "AGENCES_CREATE_REQUEST",
    AGENCES_CREATE_SUCCESS: "AGENCES_CREATE_SUCCESS",
    AGENCES_CREATE_FAILURE: "AGENCES_CREATE_FAILURE",

    AGENCES_UPDATE_REQUEST: "AGENCES_UPDATE_REQUEST",
    AGENCES_UPDATE_SUCCESS: "AGENCES_UPDATE_SUCCESS",
    AGENCES_UPDATE_FAILURE: "AGENCES_UPDATE_FAILURE",

    AGENCES_DELETE_REQUEST: "AGENCES_DELETE_REQUEST",
    AGENCES_DELETE_SUCCESS: "AGENCES_DELETE_SUCCESS",
    AGENCES_DELETE_FAILURE: "AGENCES_DELETE_FAILURE",
};
